import { render } from "./Loaders.vue?vue&type=template&id=433d5f62"
import script from "./Loaders.vue?vue&type=script&lang=js"
export * from "./Loaders.vue?vue&type=script&lang=js"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__